import React, { FC, useCallback, useMemo } from 'react';
import { setLang } from '../../lib/i18n';
import { Language } from '../../lib/i18n/translationMap';
import { languageSelector } from '../../store/form/selectors';
import { updateField } from '../../store/form/thunks';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import DropdownSelect from '../DropdownSelect/DropdownSelect';

type TOptions = {
    text: string;
    value: Language;
};

const options: TOptions[] = [
    { text: 'Русский', value: 'ru' },
    { text: 'English', value: 'en' },
    { text: 'Français', value: 'fr' },
    { text: 'Português', value: 'pt' },
    { text: 'Español', value: 'es' },
    { text: 'العربية', value: 'ar' },
];

const LanguageSelect: FC = () => {
    const dispatch = useAppDispatch();
    const language = useAppSelector(languageSelector);
    const onChange = useCallback(
        (value: string) => {
            dispatch(updateField('lang', value));
            setLang(value as Language);
        },
        [dispatch]
    );
    const activeLanguageText = useMemo(
        () => options.find(({ value }) => value === language)?.text,
        [language]
    );
    return (
        <DropdownSelect
            options={options}
            active={language}
            onChange={onChange}
            text={activeLanguageText}
            width="auto"
            dropdownType="spread"
        />
    );
};

export default LanguageSelect;
